module.exports = __webpack_public_path__ + "static/media/detail.499b4c7d.png";